













































































































































































import Basic from '@/components/widgets/Basic.vue';
import { default as Component } from 'vue-class-component';

import MessagesBlock from '@/components/snippets/messages/MessagesBlock.vue';

import HsgTariffDetailsInfoWidget from '@/components/widgets/hsg/HsgTariffDetailsInfoWidget.vue';
import HsgContractWidget from '@/components/widgets/hsg/HsgContractWidget.vue';
import HsgDeliveryWidget from '@/components/widgets/hsg/HsgDeliveryWidget.vue';
import HsgPaymentWidget from '@/components/widgets/hsg/HsgPaymentWidget.vue';
import HsgRulesWidget from '@/components/widgets/hsg/HsgRulesWidget.vue';
import HsgCongratulationsWidget from '@/components/widgets/hsg/HsgCongratulationsWidget.vue';
import HsgShowCompletedData from '@/components/widgets/hsg/HsgShowCompletedData.vue';

import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';

import Format from '@/interfaces/Format';
import Api from '@/interfaces/Api';
import Tracking from '@/interfaces/Tracking';
import SessionState from '@/interfaces/SessionState';

const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);
const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  props: {
    widgetsList: Object,
    product: Object,
    minimumAgeRequired: Number,
    defaultAddons: Array,
    availableProviders: Array,
    isMobile: Boolean
  },
  components: {
    'messages-block': MessagesBlock,
    'tariff-details-info-widget': HsgTariffDetailsInfoWidget,
    'contract-widget': HsgContractWidget,
    'delivery-widget': HsgDeliveryWidget,
    'payment-widget': HsgPaymentWidget,
    'rules-widget': HsgRulesWidget,
    'congratulations-widget': HsgCongratulationsWidget,
    'show-completed-data': HsgShowCompletedData
  },
  filters: {
    iban: formatProvider.iban(),
    date: formatProvider.date(),
    zip: formatProvider.zip()
  }
})
export default class HsgReservationWidget extends Basic {
  public paymentDetails: {
    bank: string;
    bic: string;
  } = {
    bank: '',
    bic: ''
  };
  public providers: any[] = [];
  public currentStep = 1;
  public completedSteps: {
    contract: boolean;
    vehicle: boolean;
    delivery: boolean;
    payment: boolean;
  } = {
    contract: false,
    vehicle: false,
    delivery: false,
    payment: false
  };
  public completed = false;

  public inCreation = false;

  get isCompletedContractData(): boolean {
    return !!this.sessionState.firstName;
  }
  get isDisabledContractData(): boolean {
    return this.$props.widgetsList.disabled.contract;
  }

  get isCompletedConnectTariff(): boolean {
    return this.completedSteps.vehicle;
  }
  get isDisabledConnectTariff(): boolean {
    return !this.completedSteps.contract;
  }

  get isCompletedDeliveryData(): boolean {
    return !!this.sessionState.customerSpecification;
  }
  get isDisabledDeliveryData(): boolean {
    return this.$props.widgetsList.disabled.delivery;
  }
  get isShowDeliveryWidget(): boolean {
    return this.currentStep === 2;
  }

  get isCompletedPaymentData(): boolean {
    return typeof this.sessionState.directDebit !== 'undefined';
  }
  get isDisabledPaymentData(): boolean {
    return this.$props.widgetsList.disabled.payment;
  }

  get isActiveRulesData(): boolean {
    return this.isCompletedContractData && this.isCompletedDeliveryData && this.isCompletedPaymentData;
  }
  get isDisabledRulesData(): boolean {
    return this.$props.widgetsList.disabled.rules;
  }

  get isErrorOrderCreated(): boolean {
    return typeof this.errorOrderCreated !== 'undefined' && this.errorOrderCreated !== null;
  }
  get errorOrderCreated(): string | null {
    return this.getError('orderCreated');
  }

  get salutationDisplay(): string {
    return this.getSalutationForKey(String(this.dataReview.salutation));
  }
  get billingSalutationDisplay(): string {
    return this.getSalutationForKey(String(this.dataReview.billingSalutation));
  }

  get dataReview(): SessionState {
    return this.store.getters.getSession;
  }

  get provider(): { id: any; text: string } {
    const provider = this.providers.filter((p) => {
      return p.codeNumber === this.dataReview.previousProviderCodeNumber;
    })[0];
    return provider
      ? provider
      : {
          id: null,
          text: ''
        };
  }

  public mounted(): void {
    this.checkCurrentStep();
  }

  protected setCurrentStep(step: number, disabled: boolean): void {
    if (!disabled) {
      this.currentStep = step;
    }
  }

  protected checkCurrentStep(): void {
    if (
      (this.isCompletedContractData && !this.isCompletedDeliveryData) ||
      (this.isCompletedContractData && this.isCompletedConnectTariff && !this.isCompletedDeliveryData)
    ) {
      this.currentStep = 2;
    } else if (this.isCompletedDeliveryData && !this.isCompletedPaymentData) {
      this.currentStep = 3;
    } else if (this.isCompletedPaymentData && this.isActiveRulesData) {
      this.currentStep = 4;
    } else {
      this.currentStep = 1;
    }
  }

  protected getSalutationForKey(key: string): string {
    switch (Number(key)) {
      case 1:
        return this.$t('contract.widget.salutation.mr').toLocaleString();
      case 2:
        return this.$t('contract.widget.salutation.mrs').toLocaleString();
      case 3:
        return this.$t('contract.widget.salutation.family').toLocaleString();
      case 8:
        return this.$t('contract.widget.salutation.company').toLocaleString();
      case 9:
      default:
        return '';
    }
  }

  protected getClassObject(
    step: number,
    completed: boolean
  ): { 'content-item-active': boolean; 'content-item-non-edit': boolean } {
    return {
      'content-item-active': step === this.currentStep || completed,
      'content-item-non-edit': step !== this.currentStep && !completed
    };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  protected contractSubmit(data: any): void {
    this.completedSteps.contract = true;
    this.checkCurrentStep();
    this.getSessionData();
    this.$emit('contractSubmit', data);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  protected deliverySubmit(data: any): void {
    this.completedSteps.delivery = true;
    this.checkCurrentStep();
    this.getSessionData();
    this.$emit('deliverySubmit', data);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  protected paymentSubmit(data: any): void {
    this.completedSteps.payment = true;
    this.checkCurrentStep();
    this.getSessionData();
    this.$emit('paymentSubmit', data);
  }

  protected getSessionData(): void {
    ApiProvider.sessionRead().then((response) => {
      this.store.commit('SET_SESSION', response.data);
      this.checkCurrentStep();
      if (this.dataReview && typeof this.dataReview.iban !== 'undefined') {
        ApiProvider.getBicAndBank(String(this.dataReview.iban)).then((responseIban) => {
          this.paymentDetails.bank = responseIban.data.bank;
          this.paymentDetails.bic = responseIban.data.bic;
        });
      }
    });
  }

  protected rulesSubmit(): void {
    ApiProvider.sessionRead()
      .then((sessionResponse) => {
        this.store.commit('SET_SESSION', sessionResponse.data);
        trackingProvider.orderSent();

        this.inCreation = true;
        ApiProvider.create()
          .then((response) => {
            if (response.data.success) {
              trackingProvider.orderCreated(this.dataReview, this.$props.product, this.provider, response.data.data.id);
              this.completed = true;
              this.$emit('scrollToTop');
            } else {
              trackingProvider.orderFailed();

              if (
                typeof response.data.errorMessages !== 'undefined' &&
                typeof response.data.errorMessages === 'object'
              ) {
                this.setErrorsBag(
                  'orderCreated',
                  response.data.errorMessages[0].key,
                  response.data.errorMessages[0].message
                );
              }
            }
            this.inCreation = false;
          })
          .catch((error) => {
            trackingProvider.orderFailed();
            if (error.response.status !== 500 && error.response.data.error && error.response.data.error.message) {
              this.setErrorsBag('orderCreated', '', error.response.data.error.message);
            } else {
              this.setErrorsBag('orderCreated', 'review.widget.error', this.$t('review.widget.error').toLocaleString());
            }
            this.inCreation = false;
          });
      })
      .catch((error) => {
        if (typeof error.response !== 'undefined' && error.response.data.error.message === 'session outdated') {
          localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
          window.location.href = document.referrer || window.location.origin;
        }
      });
  }

  private editHsgInfo(step) {
    localStorage.removeItem(`reservation-completed-${step}`);
    this.completedSteps[step] = false;
    if (step === 'vehicle') {
      this.currentStep = 1;
    } else {
      this.$emit('switchWidget', step);
      switch (step) {
        case 'contract':
          this.currentStep = 1;
          break;
        case 'delivery':
          this.currentStep = 2;
          break;
        case 'payment':
          this.currentStep = 3;
          break;
      }
    }
  }

  private setErrorsBag(errorKey: string, localeKey: string, message: string) {
    if (typeof this.errorsBag === 'undefined' || this.errorsBag === null) {
      this.errorsBag = {
        [errorKey]: [
          {
            key: localeKey,
            message
          }
        ]
      };
    } else {
      this.errorsBag[errorKey] = [
        {
          key: localeKey,
          message
        }
      ];
    }
  }
}
